import { render, staticRenderFns } from "./GLFlower.vue?vue&type=template&id=2711a5bb&"
import script from "./GLFlower.vue?vue&type=script&lang=js&"
export * from "./GLFlower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports